import config from "../config/environment";

const GO_BACKEND_URL = config.GO_BACKEND_URL;

function getAuthHeaders() {
  const token = sessionStorage.getItem("auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
}

const pushRulesService = {
  async getRules() {
    const res = await fetch(`${GO_BACKEND_URL}/push-rules`, {
      headers: { ...getAuthHeaders() },
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  },

  async createRule(rule) {
    const res = await fetch(`${GO_BACKEND_URL}/push-rules`, {
      method: "POST",
      headers: { "Content-Type": "application/json", ...getAuthHeaders() },
      body: JSON.stringify(rule),
    });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data.error || `HTTP ${res.status}`);
    }
    return res.json();
  },

  async updateRule(id, rule) {
    const res = await fetch(`${GO_BACKEND_URL}/push-rules/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", ...getAuthHeaders() },
      body: JSON.stringify(rule),
    });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data.error || `HTTP ${res.status}`);
    }
    return res.json();
  },

  async deleteRule(id) {
    const res = await fetch(`${GO_BACKEND_URL}/push-rules/${id}`, {
      method: "DELETE",
      headers: { ...getAuthHeaders() },
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  },

  async getFields() {
    const res = await fetch(`${GO_BACKEND_URL}/push-rule-fields`, {
      headers: { ...getAuthHeaders() },
    });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  },
};

export default pushRulesService;
